// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": () => import("../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---shared-ui-payment-policy-terms-and-condition-js": () => import("../../shared-ui/PaymentPolicy/terms-and-condition.js" /* webpackChunkName: "component---shared-ui-payment-policy-terms-and-condition-js" */)
}

